import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';
import { Reveal } from './Reveal';
export function Bonuses() {
  return <section className="bg-white py-20 sm:py-28" aria-labelledby="bonos-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-15" data-mp="pm2bbv98hdgi">
      <div className="mx-auto max-w-6xl px-6" data-id="element-16" data-mp="ftmr0ragscsg">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.8fr)] lg:items-end" data-id="element-17" data-mp="fsbsp6zsfx8q">
          <Reveal data-id="element-18" data-mp="1t3pm30i84z9">
            <p className="inline-flex items-center gap-2 rounded-full bg-mint-50 px-3.5 py-1.5 text-sm font-medium text-mint-700 ring-1 ring-inset ring-mint-200" data-id="element-19" data-mp="1wrh6wme2hbc">
              <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="3o368sdzxmyfq" />
              Incluidos sin costo extra
            </p>
            <h2 id="bonos-title" className="mt-5 font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-21" data-mp="3t2slmmbumco0">
              Más los 5 bonos estratégicos
            </h2>
            <p className="mt-4 max-w-xl text-lg text-ink-soft" data-id="element-22" data-mp="1r8tf0e9o8jhn">
              Las herramientas que convierten el protocolo en algo que podés
              sostener en la vida real: viajes, salidas, recaídas y días difíciles.
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-23" data-mp="3r79tfk4ko4no">
            <img src="https://cdn.magicpatterns.com/uploads/w2euMroWfvQtfTbdfisj6n/e917eb8e-922b-4b66-99bf-315fb96d2d3a_(1).webp" alt="Los 5 bonos del MegaPack presentados como cuadernillos" className="w-full rounded-2xl bg-mint-50 object-cover" width={900} height={600} loading="lazy" decoding="async" data-id="element-24" data-mp="3r68f96s9f21q" />
          </Reveal>
        </div>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="38g8totvmo532">
          {bonos.map((bono, index) => <li key={bono.number} className="flex" data-id="element-26" data-mp="33h5n35001qsz" data-mpi={index}>
              <Reveal delay={index * 0.04} className="flex h-full w-full flex-col rounded-2xl border border-mint-200 bg-mint-50/60 p-7" data-id="element-27" data-mp="33ge54wzbrrl6">
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-mint-600" data-id="element-28" data-mp="nrukkm7xk144">
                  Bono {bono.number}
                </p>
                <h3 className="mt-3 font-display text-xl leading-snug text-ink" data-id="element-29" data-mp="3ci4utcnlfhrt">
                  {bono.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-30" data-mp="3hk3y6mjc2eor">
                  {bono.description}
                </p>
                <p className="mt-auto flex items-baseline gap-2 pt-6" data-id="element-31" data-mp="3qj7j7w22945w">
                  <span className="text-sm text-ink-muted line-through" data-id="element-32" data-mp="3qgbjq3ake7fc">
                    {bono.price}
                  </span>
                  <span className="text-sm font-semibold uppercase tracking-wide text-mint-700" data-id="element-33" data-mp="2xtihthlfv23r">
                    Gratis
                  </span>
                </p>
              </Reveal>
            </li>)}
        </ul>

        <Reveal delay={0.04} data-id="element-34" data-mp="37kv6y1fure63">
          <div className="mt-10 flex flex-col items-start justify-between gap-4 rounded-2xl bg-mint-600 px-8 py-7 text-white sm:flex-row sm:items-center" style={{
          alignItems: "center",
          justifyContent: "center"
        }} data-id="element-35" data-mp="37l4rh9i4ot4e">
            <div data-id="element-36" data-mp="27kjet4kwonod">
              <p className="text-sm uppercase tracking-[0.16em] text-mint-100" data-id="element-37" data-mp="27iyib9f16unv">
                Valor total de los 5 bonos
              </p>
              <p className="mt-1 font-display text-3xl" data-id="element-38" data-mp="22itz3bmqnlty">
                <span style={{
                textDecorationLine: "line-through"
              }} data-id="element-39" data-mp="1xksiqygp60m6"> 43,00 €  </span> <span className="text-mint-100" style={{
                fontWeight: "800"
              }} data-id="element-40" data-mp="1tj6z8u9nqo30">   hoy gratis</span>
              </p>
            </div>
            
          </div>
        </Reveal>
      </div>
    </section>;
}